import { useContext } from 'react';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUIConnectLogo from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import Navigation from './Navigation';
import LoginSignupButtons from '../AuthButtons/LoginSignupButtons';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';
import { useBreakpointValue } from '@chakra-ui/react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SiteHeader = ({
  children
}) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsxs(CUIBox, {
    padding: {
      base: 8,
      sm: 10
    },
    children: [/*#__PURE__*/_jsxs(CUIFlex, {
      direction: {
        base: 'row',
        md: 'row'
      },
      align: "center",
      width: "100%",
      justify: "space-between",
      children: [/*#__PURE__*/_jsxs(CUIRouterLink, {
        to: "/",
        onClick: () => trackInteraction('click header nav logo'),
        order: {
          base: 0,
          md: 0
        },
        maxW: {
          base: '100%',
          sm: '180px'
        },
        children: [/*#__PURE__*/_jsx(CUIConnectLogo, {
          alt: I18n.text('app.homepage.header.logoAlt'),
          width: "100%",
          display: {
            base: 'none',
            sm: 'block'
          }
        }), /*#__PURE__*/_jsx(CUIConnectLogo, {
          use: "icon",
          width: "50px",
          display: {
            base: 'block',
            sm: 'none'
          }
        })]
      }), /*#__PURE__*/_jsx(Navigation, {}), !isMobile && /*#__PURE__*/_jsx(LoginSignupButtons, {
        direction: "row",
        display: {
          md: 'flex'
        },
        py: {
          base: 4,
          md: 0
        },
        trackingIdentifier: "navigation-bar"
      })]
    }), children && /*#__PURE__*/_jsx(CUIFlex, {
      marginTop: 10,
      maxW: "1000px",
      ml: "auto",
      mr: "auto",
      children: children
    })]
  });
};
export default SiteHeader;